//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UniPopup',
  props: {
    /**
			 * 页面显示
			 */
    show: {
      type: Boolean,
      default: false
    },
    /**
			 * 对齐方式
			 */
    position: {
      type: String,
      // top - 顶部， middle - 居中, bottom - 底部
      default: 'middle'
    },
    /**
			 * 显示模式
			 */
    mode: {
      type: String,
      default: 'insert'
    },
    /**
			 * 额外信息
			 */
    msg: {
      type: String,
      default: ''
    },
    /**
			 * h5遮罩是否到顶
			 */
    h5Top: {
      type: Boolean,
      default: false
    },
    buttonMode: {
      type: String,
      default: 'bottom'
    }
  },
  data () {
    return {
      offsetTop: 0
    }
  },
  watch: {
    h5Top (newVal) {
      if (newVal) {
        this.offsetTop = 44
      } else {
        this.offsetTop = 0
      }
    }
  },
  created () {
    let offsetTop = 0







    this.offsetTop = offsetTop
  },
  methods: {
    hide () {
      if (this.mode === 'insert' && this.position === 'middle') return
      this.$emit('hidePopup')
    },
    closeMask () {
      if (this.mode === 'insert') {
        this.$emit('hidePopup')
      }
    },
    moveHandle () {}
  }
}
